module.exports = __webpack_public_path__ + "img/tiktok.4c404779.png";